export var WalletType;
(function (WalletType) {
    /**
     * 獎勵錢包
     */
    WalletType[WalletType["ACTIVITY"] = 0] = "ACTIVITY";
    /**
     * 中心錢包
     */
    WalletType[WalletType["CENTER"] = 1] = "CENTER";
    /**
     * VR 彩票
     */
    WalletType[WalletType["VR"] = 2] = "VR";
    /**
     * OG 真人
     */
    WalletType[WalletType["OG"] = 3] = "OG";
    /**
     * AE 电子 遊戲已移除
     */
    WalletType[WalletType["AE"] = 4] = "AE";
    /**
     * BBIN 真人 遊戲已移除
     */
    WalletType[WalletType["BBIN"] = 5] = "BBIN";
    /**
     * DT 电子 遊戲已移除
     */
    WalletType[WalletType["DT"] = 6] = "DT";
    /**
     * JDB 电子
     */
    WalletType[WalletType["JDB"] = 7] = "JDB";
    /**
     * IM 体育
     */
    WalletType[WalletType["IM"] = 9] = "IM";
    /**
     * 开元棋牌
     */
    WalletType[WalletType["KY"] = 10] = "KY";
    /**
     * 泛亚电竞（开心电竞）遊戲已移除
     */
    WalletType[WalletType["AVIA"] = 11] = "AVIA";
    /**
     * 沙巴体育 遊戲已移除
     */
    WalletType[WalletType["SABA"] = 12] = "SABA";
    /**
     * 欧博真人 遊戲已移除
     */
    WalletType[WalletType["AB"] = 13] = "AB";
    /**
     * PA 真人
     */
    WalletType[WalletType["PA"] = 14] = "PA";
    /**
     * CQ9 电子
     */
    WalletType[WalletType["CQ9"] = 15] = "CQ9";
    /**
     * eBET 真人 遊戲已移除
     */
    WalletType[WalletType["EBET"] = 16] = "EBET";
    /**
     * 皇冠體育（黃金甲體育） 遊戲已移除
     */
    WalletType[WalletType["CROWN"] = 17] = "CROWN";
    /**
     * 凱旋棋牌（GA 棋牌）
     */
    WalletType[WalletType["KX"] = 18] = "KX";
    /**
    * 小艾電競
    */
    WalletType[WalletType["ILUSTRE"] = 19] = "ILUSTRE";
    /**
     * 雷火電競 (GA 電競)
     */
    WalletType[WalletType["TF"] = 20] = "TF";
    /**
     * BTI 體育
     */
    WalletType[WalletType["BTI"] = 21] = "BTI";
    /**
     * 高登棋牌 遊戲已移除
     */
    WalletType[WalletType["GF"] = 22] = "GF";
    /**
     * 發財電子
     */
    WalletType[WalletType["FC"] = 23] = "FC";
    /**
     * AI 体育
     */
    WalletType[WalletType["AI"] = 24] = "AI";
    /**
     * 雙贏 彩票
     */
    WalletType[WalletType["SGWIN"] = 25] = "SGWIN";
    /**
     * KG 真人 遊戲已移除
     */
    WalletType[WalletType["KG"] = 26] = "KG";
    /**
     * 保利體育 遊戲已移除
     */
    WalletType[WalletType["POLY"] = 27] = "POLY";
    /**
     * KS 棋牌
     */
    WalletType[WalletType["KS"] = 28] = "KS";
    /**
     * BG 真人
    */
    WalletType[WalletType["BG"] = 29] = "BG";
    /**
     * PG 電子
     */
    WalletType[WalletType["PG"] = 30] = "PG";
    /**
     * PP 電子
     */
    WalletType[WalletType["PP"] = 31] = "PP";
    /**
     * FB 體育
     */
    WalletType[WalletType["FB"] = 32] = "FB";
    /**
     * PM 體育
     */
    WalletType[WalletType["PM"] = 33] = "PM";
    /**
     * DB真人
    */
    WalletType[WalletType["DB"] = 34] = "DB";
    /**
     * DB 電競
     */
    WalletType[WalletType["DB2"] = 35] = "DB2";
})(WalletType || (WalletType = {}));
//# sourceMappingURL=WalletType.js.map